import { useState, useEffect, useRef } from "react"

import { API, graphqlOperation } from 'aws-amplify';
import { listChats } from '../graphql/queries';
import { onUpdateChat, onCreateChat } from '../graphql/subscriptions';

import userStore from '../store/user';

import { Layout } from "element-react"
import ChatItem from "../components/ChatItem"
import PagerQuery from "../utils/PagerQuery";

let onUpdateChatSubscription;
let onCreateChatSubscription;
export default function ChatItemsContainer( { indexChat, onChatSelect, filterValue , chatTypeFilter ,  onEmptyChats } ) {
    const { user } = userStore();
    
    //const [[chats, setChats], [loadingChats, setLoadingChats], [selectedChatId, setSelectedChatId]] = [useState([]), useState(false), useState([]), useState(null)]
    
    const [chats, setChats] = useState([]);
    const [loadingChats, setLoadingChats] = useState(false);
    const [selectedChatId, setSelectedChatId] = useState(null);
    const isInitialLoad = useRef(true);

    /*useEffect(function() {
        console.log("subscribing to on update chat ...")
        onUpdateChatSubscription = API.graphql(graphqlOperation(onUpdateChat)).subscribe({ next: subscription, error: error => console.warn(error) });
        onCreateChatSubscription = API.graphql(graphqlOperation(onCreateChat)).subscribe({ next: subscription, error: error => console.warn(error) });
        //setAmplifySubscription([onUpdateChatSubscription, onCreateChatSubscription])
        setLoadingChats(true)
        loadChats()
        return () =>{
            console.log('UNMOUNT SUBSCRIPTION');
            onUpdateChatSubscription.unsubscribe();
            onCreateChatSubscription.unsubscribe();
            console.log('AFTER SUBSCRIPTION');
        }
    }, [user])*/

    useEffect(() => {
        // Carga inicial de los chats
        loadChats();

        // Función genérica para manejar los datos de las suscripciones
        const handleSubscriptionUpdate = (data, subscriptionType) => {
            const updatedChat = data.value.data[subscriptionType];
            
            // Verificamos que el chat pertenezca al usuario actual
            if (!updatedChat || (updatedChat.company_user !== user.cognitoId && updatedChat.owner !== user.cognitoId)) {
                return;
            }

            setChats(prevChats => {
                let newChats = [];
                // Buscamos si el chat ya existe en nuestra lista
                const chatIndex = prevChats.findIndex(chat => chat.id === updatedChat.id);

                if (chatIndex > -1) { // Si el chat existe (es una actualización)
                    newChats = [...prevChats];
                    newChats[chatIndex] = { ...newChats[chatIndex], ...updatedChat }; // Actualizamos el chat
                } else { // Si no existe (es un chat nuevo)
                    newChats = [{ ...updatedChat, chat_type: user.cognitoId === updatedChat.company_user ? "S" : "B" }, ...prevChats];
                }

                // Re-ordenamos la lista para poner el más reciente al principio
                return newChats.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            });
        };

        // Creamos las suscripciones
        const onUpdateSubscription = API.graphql(graphqlOperation(onUpdateChat)).subscribe({
            next: (data) => handleSubscriptionUpdate(data, 'onUpdateChat')
        });
        const onCreateSubscription = API.graphql(graphqlOperation(onCreateChat)).subscribe({
            next: (data) => handleSubscriptionUpdate(data, 'onCreateChat')
        });

        // Función de limpieza para cancelar las suscripciones al salir
        return () => {
            onUpdateSubscription.unsubscribe();
            onCreateSubscription.unsubscribe();
        };
    }, [user]);

    /*const subscription = (data) => {
        console.log('CALLING SUBSCRIPTION METHOD')
        const chatItem = data.value.data.onUpdateChat
        if(!loadingChats) {
            if(chatItem && (chatItem.company_user === user.cognitoId || chatItem.owner === user.cognitoId)) {
            //if((user.type === "S" && chatItem && chatItem.company_user === user.cognitoId) || (user.type === "B" && chatItem.owner === user.cognitoId)) {
                setLoadingChats(true)
                loadChats()
            }
        }
    }*/

    async function loadChats() {
        let filter = {
            or: [
                { 'company_user': { eq: user.cognitoId } },
                { 'owner': { eq: user.cognitoId } }
            ]
        }

        const pagerQuery = new PagerQuery(listChats, { filter }, Object.keys({ listChats }));
        const listChatsResult = await pagerQuery.searchPrivateData();
        let resultChats = listChatsResult.data.listChats.items;

        for(let i = 0; i < resultChats.length; i++) {
            resultChats[i]["chat_type"] = user.cognitoId === resultChats[i].company_user ? "S" : "B";
        }

        resultChats = resultChats.sort((a,b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        
        if(resultChats.length === 0 && onEmptyChats){
            onEmptyChats(true);
        }
        setChats(resultChats);
        setLoadingChats(false);

        // Solo ejecutamos esto en la primera carga del componente
        if (isInitialLoad.current) {
            chatFromParameter(resultChats);
            isInitialLoad.current = false; // Desactivamos la bandera para futuras ejecuciones
        }
    }

    function chatFromParameter(resultChats){
        console.log('indexChat :: ' + indexChat);
        if(indexChat !== 0 && indexChat !== "0"){
            try{
                let chat = resultChats.find((chat) => chat.id === indexChat);
                if(chat === undefined)
                    chat = resultChats[indexChat-1];
                setSelectedChatId(chat.id);
                onChatSelect(chat)
            }catch(e){
                console.error(e);
            }
        }else{
            console.log('Current CHAT ID :: ' + selectedChatId);
            if(selectedChatId){
                setSelectedChatId("");
                //onChatSelect(null);
            }
        }
    }

    function chatSelectHandler(chatId) {
        const chat = chats.filter((chat) => chat.id === chatId)[0]
        setSelectedChatId(chat.id)
        if(onChatSelect)
            onChatSelect(chat)
    }

    const renderChatItems = chats.map(chat => {
        let chatItem = <ChatItem chat={chat} key={chat.id} onClick={chatSelectHandler} isActiveChat={selectedChatId && selectedChatId === chat.id} />
        if(chat.company_user_name.toLowerCase().includes(filterValue.toLowerCase()) || chat.owner_name.toLowerCase().includes(filterValue.toLowerCase())) {
            if(chatTypeFilter === "" || chat.chat_type === chatTypeFilter) 
                return chatItem
            return <></>
        } else 
            return <></>
    })

    return (
        <Layout.Col span="24" className="m-t-md chat-items-container">
            {chats ? renderChatItems : <></>}
        </Layout.Col>
    )
}
